import moment from 'moment'

export default {
  methods: {
    asDate (date) {
      return moment(date, moment.ISO_8601)
        .locale(this.currentLocale === 'de' ? 'de' : 'en-gb')
        .format('L')
    },
    timestampAsDate (timestamp) {
      return moment(timestamp, moment.ISO_8601)
      .locale(this.currentLocale === 'de' ? 'de' : 'en-gb')
      .format('L')
    },
    asTimestamp (timestamp) {
      return moment(timestamp, moment.ISO_8601)
        .locale(this.currentLocale === 'de' ? 'de' : 'en-gb')
        .format('LL, LT')
    },
    asFromNow (timestamp) {
      return moment(timestamp, moment.ISO_8601)
        .locale(this.currentLocale === 'de' ? 'de' : 'en-gb')
        .fromNow()
    },
    changeLanguage (locale) {
      this.$store.dispatch('setLanguage', locale)
    },
    currentDateString () {
      return moment()
        .locale(this.currentLocale === 'de' ? 'de' : 'en-gb')
        .format('LL, LT')
    },
    duration (beginDate, endDate) {
      if (this.currentLocale === 'de') {
        return `${moment(beginDate, moment.ISO_8601).format('MM.YYYY')} - ${endDate ? moment(endDate, moment.ISO_8601).format('MM.YYYY') : 'laufend'}`
      } else {
        return `${moment(beginDate, moment.ISO_8601).format('MM/YYYY')} - ${endDate ? moment(endDate, moment.ISO_8601).format('MM/YYYY') : 'ongoing'}`
      }
    }
  },
  computed: {
    currentLocale () {
      return this.$language.current.substring(0, 2).toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/DateTimeHelper.js